import React from "react";
import { RvDto } from "../../types/rv";
import {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableHead,
  TableCell,
} from "../../Components/Table";
import { RvStatusLabels } from "../../constants";

interface PatientAppointmentsTableProps {
  appointments: { encounterData: RvDto; patientName: string; amka: string }[];
  patientId: number;
}

export const PatientAppointmentsTable: React.FC<
  PatientAppointmentsTableProps
> = ({ appointments, patientId }) => {
  // Φιλτράρουμε τα ραντεβού αποκλειστικά για το συγκεκριμένο patientId
  const patientRvs = appointments.filter(
    (app) => app.encounterData.patientId === patientId,
  );

  if (patientRvs.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center h-full p-8 text-gray-500">
        <p className="text-lg font-medium">
          Δεν βρέθηκαν ραντεβού για τον επιλεγμένο ασθενή.
        </p>
      </div>
    );
  }
  const firstRv = patientRvs[0].encounterData;
  const fullName =
    `${firstRv.patientLastName || ""} ${firstRv.patientFirstName || ""}`.trim();
  const displayName = fullName !== "" ? fullName : `Ασθενής (${patientId})`;
  return (
    <div className="w-full h-full overflow-y-auto">
      <div className="mb-4">
        <h3 className="text-lg font-bold text-gray-800">
          Ιστορικό Ραντεβού ({displayName})
        </h3>
      </div>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Ημερομηνία</TableHead>
            <TableHead>Ώρα Έναρξης</TableHead>
            <TableHead>Ώρα Λήξης</TableHead>
            <TableHead>Λόγος Ραντεβού</TableHead>
            <TableHead>Κατάσταση</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {patientRvs.map((app, index) => {
            const rv = app.encounterData;
            return (
              <TableRow key={rv.rvId || index}>
                <TableCell className="font-medium">{rv.day || "-"}</TableCell>
                <TableCell>{rv.startTime || "-"}</TableCell>
                <TableCell>{rv.endTime || "-"}</TableCell>
                <TableCell>{rv.rvReason || "Ραντεβού"}</TableCell>
                <TableCell>
                  <span className="px-2 py-1 text-xs font-semibold rounded-full bg-blue-100 text-blue-700">
                    {/* Αν το rv.status είναι αριθμός ή κείμενο, το μεταφράζουμε με ασφάλεια */}
                    {RvStatusLabels[rv.status as keyof typeof RvStatusLabels] ||
                      rv.status ||
                      "Scheduled"}
                  </span>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
};

export default PatientAppointmentsTable;
